import _toConsumableArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
// MutationsStatus.js
import React, { useEffect } from 'react';
import { useTranslation } from 'config/i18n';
import { ERRORS_CATEGORIES } from 'constants/errors';
import { useSnackbar } from '@app/providers/SnackbarProvider';
import Snackbar from '../Snackbar';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var SnackNotifications = function SnackNotifications(_ref) {
  var loading = _ref.loading,
    error = _ref.error,
    success = _ref.success,
    errorMessage = _ref.errorMessage,
    successMessage = _ref.successMessage;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useSnackbar = useSnackbar(),
    showSnackbar = _useSnackbar.showSnackbar,
    hideSnackbar = _useSnackbar.hideSnackbar;
  var type = 'loading';
  var getMessage = function getMessage(snackType) {
    var message = [];
    if (snackType === 'loading') {
      message = [/*#__PURE__*/_jsx("div", {
        children: t('loading')
      })];
    }
    if (snackType === 'success') {
      message = [/*#__PURE__*/_jsx("div", {
        children: t('success')
      })];
    }
    if (type === 'error') {
      var _ref2 = error || {},
        _ref2$graphQLErrors = _ref2.graphQLErrors,
        graphQLErrors = _ref2$graphQLErrors === void 0 ? null : _ref2$graphQLErrors,
        _ref2$message = _ref2.message,
        graphMessage = _ref2$message === void 0 ? null : _ref2$message;
      message = [/*#__PURE__*/_jsx(_Fragment, {
        children: errorMessage || t('sorry.error')
      })];
      if (graphQLErrors && graphQLErrors.length > 0) {
        // iterate all GraphQL errors
        for (var i = 0; i < graphQLErrors.length; i += 1) {
          // Check error type:
          switch (graphQLErrors[i].extensions.category) {
            // If it's a validation error display validation message
            case ERRORS_CATEGORIES.VALIDATION:
              {
                message = [
                  // <>
                  //   <div>{graphMessage}</div>
                  //   <br />
                  // </>,
                ];
                var validationMessages = Object.values(graphQLErrors[i].extensions.validation).reduce(function (acc, val) {
                  return [].concat(_toConsumableArray(acc), _toConsumableArray(val));
                });
                message.push(validationMessages.map(function (msg) {
                  return /*#__PURE__*/_jsxs(_Fragment, {
                    children: [msg, /*#__PURE__*/_jsx("br", {})]
                  });
                }));
                break;
              }
            //  if it's an authentication error display the message from the server.
            case ERRORS_CATEGORIES.AUTHENTICATION:
              message = [/*#__PURE__*/_jsx("div", {
                children: graphMessage
              })];
              break;
            case ERRORS_CATEGORIES.BAD_REQUEST:
              message = [/*#__PURE__*/_jsx("div", {
                children: graphMessage
              })];
              break;

            // otherwise display the default message:
            default:
              message = [/*#__PURE__*/_jsx(_Fragment, {
                children: t('sorry.error')
              })];
              break;
          }
        }
      }
    }
    return /*#__PURE__*/_jsx("div", {
      children: message
    });
  };
  useEffect(function () {
    if (error) {
      type = 'error';
    }
    if (success) {
      type = 'success';
    }
    if (loading || error || success) {
      showSnackbar(type, getMessage(type));
    } else {
      hideSnackbar();
    }
  }, [loading, error, success]);
  return null;
};
SnackNotifications.defaultProps = {
  loading: undefined,
  error: undefined,
  success: undefined,
  errorMessage: null,
  successMessage: null
};
export default SnackNotifications;